// The SDD sign-in of the header: its steps in a dialog over the current page. Without script the link opens the full page.
(function($, $i) {
  // Asks the site to leave its chrome out, so that the response is just the body of the dialog.
  function undecorated(url) {
    return url + (url.indexOf('?') < 0 ? '?' : '&') + 'nodecorator=true';
  }

  function openDialog($link) {
    var entryUrl = undecorated($link.attr('href'));
    var networkError = $link.data('pair-network-error');
    var submitter = null;
    var dialog = $i.dialog({
      title: $link.data('pair-dialog-title'),
      body: '<div class="dialog-ajax-placeholder">' + $i.i18n.get('main.help.loading') + '</div>',
      buttonKeys: {},
      width: 480,
      // Every opening starts afresh with a new form token, so a closed dialog is thrown away.
      close: function() {
        this.box.remove();
        this.overlay.remove();
      }
    });
    var $body = dialog.box.find('.dialog-body').addClass('sdd-pairing-dialog');

    function show(content) {
      $body.html(content);
      dialog.resize();
      $body.find('input[type="text"], button, [data-pair-restart]').first().trigger('focus');
    }

    function load(request) {
      $.ajax($.extend({ dataType: 'html', cache: false }, request))
        .done(show)
        .fail(function(xhr) {
          // A lost session answers 401 with the sign-in address, which the global AJAX handler opens.
          if (xhr.status !== 401 || !xhr.getResponseHeader('Login-Form-Url')) {
            show($('<p class="alert alert-error"></p>').text(networkError));
          }
        });
    }

    $body.on('click', 'button[type="submit"]', function() {
      submitter = this;
    });
    $body.on('submit', 'form', function(e) {
      // Digidentity must take the whole window, so that form is posted by the browser itself.
      if ($(this).is('[data-pair-top]')) {
        $(this).find('input[name="returnPage"]').val(window.location.pathname + window.location.search);
        return;
      }
      var data = $(this).serializeArray();
      e.preventDefault();
      // A serialized form leaves out the button that sent it, which carries the decision of the confirmation.
      if (submitter && submitter.name && $.contains(this, submitter)) {
        data.push({ name: submitter.name, value: submitter.value });
      }
      submitter = null;
      $(this).find('button').prop('disabled', true);
      load({ url: undecorated(this.action), type: 'POST', data: $.param(data) });
    });
    $body.on('click', '[data-pair-restart]', function(e) {
      e.preventDefault();
      load({ url: entryUrl, type: 'GET' });
    });
    $body.on('click', '[data-pair-close]', function() {
      dialog.close();
    });

    load({ url: entryUrl, type: 'GET' });
  }

  $(document).on('click', 'li.sdd-pairing-link > a', function(e) {
    // A new tab gets the full page, and so does the full page itself, whose form the dialog would duplicate.
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.which > 1 || $('#sdd-pairing-page, .sdd-pairing-dialog').length) {
      return;
    }
    e.preventDefault();
    openDialog($(this));
  });

  // Back from Digidentity: the dialog opens again over the page it was opened on.
  $(function() {
    var $link = $('li.sdd-pairing-link > a');
    if (window.location.hash !== '#sdd-pairing' || !$link.length || $('#sdd-pairing-page').length) {
      return;
    }
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
    openDialog($link.first());
  });
})(jQuery, isis);
